import { ReactNode } from 'react';
import { lt } from '@mews/framework';
import { CurrencyInputField, CurrencyInputFieldProps } from '@mews-commander/form';
import { useCurrencyFormat } from '../../../../core/globalization/hooks/useCurrencyFormat';

interface PaymentAmountInputFieldProps
    extends Omit<CurrencyInputFieldProps, 'prefix' | 'suffix' | 'currencyCultureInfo' | 'helper'> {
    currencyCode: string;
    helper?: ReactNode;
    label?: ReactNode;
}

export const PaymentAmountInputField = ({
    currencyCode,
    helper,
    label,
    required = true,
    ...props
}: PaymentAmountInputFieldProps) => {
    const currencyFormat = useCurrencyFormat(currencyCode);

    return (
        <CurrencyInputField
            {...props}
            label={label ?? lt('GeneralAmountPrice')}
            required={required}
            fixedDecimalScale
            helper={helper}
            {...currencyFormat}
            precision={2}
        />
    );
};
